import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { forwardRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { CanvasOffscreenProvider } from '../CanvasOffscreen/canvas-offscreen.js';
import style from './page-root.module.scss.js';

const PageRoot = /*#__PURE__*/forwardRef(function PageRoot(_ref, ref) {
  let {
    opened,
    embedded,
    customIntro,
    mode
  } = _ref;
  const {
    Font,
    PageMain
  } = useLlm(state => state.components);
  const classNames = getClassNames(style.root, 'llm', {
    '-open': opened,
    '-embedded': embedded,
    '-custom-intro': customIntro,
    ['-' + mode]: true
  });
  return jsx("section", {
    ref: ref,
    className: classNames,
    "data-opened": opened,
    "data-embedded": embedded,
    "data-custom-intro": customIntro,
    "data-mode": mode,
    children: jsxs(CanvasOffscreenProvider, {
      children: [jsx(Font, {}), jsx(PageMain, {}, "main")]
    })
  });
});

export { PageRoot };
//# sourceMappingURL=page-root.js.map
